import { makeStyles } from 'tss-react/mui'

export default makeStyles()({
  content: {
    position: 'relative',
    zIndex: '2',
    '& input, & .MuiSelect-select': {
      padding: '18px 6px',
    },
    '& .MuiInputBase-root': {
      paddingLeft: 18,
      paddingRight: 18,
    },
    '& .MuiSelect-icon': {
      right: 18,
    },
  },
})
